export enum ENGAGEMENT {
  MIN_INSTAGRAM = 0.1,
  MAX_INSTAGRAM = 35,
  MIN_REST = 0,
  MAX_REST = 100
}

export enum FOLLOWERS {
  MIN = 1000,
  MAX = 20000075
}

export enum GENDER_RATIO {
  MIN = 0,
  MAX = 100
}

export enum VIEWS {
  MIN = 0,
  MAX = 6000075
}
